import { forkJoin } from 'rxjs';
import { QuizEnvelop } from 'src/app/_models/quizEnvelop';
import { ImageService } from './../../../_services/image.service';

import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Question } from 'src/app/_models/question';
import { ResultData } from 'src/app/_models/ResultData';
import { QuestionService } from 'src/app/_services/question.service';
import Swal from 'sweetalert2';
declare var $ : any;
@Component({
  selector: 'app-view-task-sample',
  templateUrl: './view-task-sample.component.html',
  styleUrls: ['./view-task-sample.component.css']
})
export class ViewTaskSampleComponent implements OnInit {
   question=undefined
  title=""
   quizEnvelop = new QuizEnvelop()
   questionIndex=1
   isLastQuestion=true
   server_task_template_id=0
   nextId=0
   prevId=1
   doQuestionForm:FormGroup
   answerGiven:any
   loading=true
   generating=false
   reloading=false
   questionText=undefined
  constructor(
    private route:ActivatedRoute,
    private imageService:ImageService,
    private questionService:QuestionService,
  private router:Router) { }

  ngOnInit(): void {

    this.route.params.subscribe(
      params=>{
        this.server_task_template_id = +params['server_task_template_id']
        this.nextId=this.server_task_template_id+1
        if(this.server_task_template_id!=0){
          this.prevId=this.server_task_template_id-1
        }
        if(this.server_task_template_id!=0){
          this.questionService.getSampleTask(this.server_task_template_id).subscribe(
            {next:(data:ResultData)=>{
              this.question=data.rs.data
              this.initForm()
              this.processImages(this.question)
            },error:(err)=>{
              console.error("error reading sample task",err)
            }

            }
          )
        }

      }
    )

  }
  reloadSampleTask(){
    this.reloading=true
    this.question=undefined
    this.questionService.getSampleTask(this.server_task_template_id).subscribe(
      {next:(data:ResultData)=>{
        this.setQuestionToNullIfNoTemplate(data.rs.data)
      },error:(err)=>{
        console.error("error reading sample task",err)
      }

      }
    )
  }
  generateSampleTask(){
  this.question=undefined
  this.generating=true
  this.questionService.generateSampleTask(this.server_task_template_id).subscribe(
    {next:(data:ResultData)=>{
      this.setQuestionToNullIfNoTemplate(data.rs.data)
    },error:(err)=>{
      console.error("error reading sample task",err)
    }
  }
  )
  }
setQuestionToNullIfNoTemplate(q:any){
  if(q.server_question_id==0){
    this.question=undefined
    this.loading=false
    Swal.fire( 'Oops',"No Template Found for id="+q.server_question_id,'info')
  }else{
    this.question=q
    this.processImages(this.question)
  }

}
initForm(){

  if(this.question.is_input){
    const c1={'answerInput': new FormControl("")}
    this.doQuestionForm= new FormGroup(c1)
  }else if(this.question.is_radio_group){
    const c={'answerChoice': new FormControl("")}
    this.doQuestionForm= new FormGroup(c)
  }
}
extractChoiceValue(choice){
  return choice.value
}
async processImages(question:Question){
  let qText = question.questionText
  let myImages= question.imageListQuestionBody

  let iLength = myImages.length

  if(iLength==0){
    this.questionText=question.questionText
    this.loading=false
    this.generating=false
    this.reloading=false
  }

 const imageObservables =myImages.map(pp=>this.imageService.questionObservableImage(this.question.server_question_id,pp['media_file_name']))
 forkJoin(imageObservables).subscribe({
  next:(resultArray)=>{
  for(let i=0;i < resultArray.length;i++){
  let iValue = resultArray[i].rs.data

  let  myImageData = myImages[i]
  let  partName = myImageData['name']
  let  placement = myImageData['placement']
  let imagePlaceHoler = "@@image"+partName
  let imageSource =  "<img src=data:image/png;base64,"+iValue+">"
  if(placement!="IN_LINE_YES"){imageSource= "<div>"+imageSource+"</div>"}

  qText =this.replaceAll(qText,imagePlaceHoler,imageSource)

}
this.questionText=qText

this.loading=false
this.generating=false
this.reloading=false
},error:(err)=>{
  console.error("Error loading images",err)
}
}
)
}

replaceAll(str:string, find:string, replace) {
return str.replace(new RegExp(find,'g'), replace);
}

viewSampleTaskDetailPopUp(){
  $("#sampleDetailId").modal("show");
}

onViewSampleDetailFinished(){
  $("#sampleDetailId").modal("hide");

}
moveNext(){
  this.question=undefined
  this.router.navigate(['/task/template/sample/', this.nextId])
}
movePrevious(){
  this.question=undefined
  this.router.navigate(['/task/template/sample/', this.prevId])
}

}
